/**
 * @fileoverview Checkbox rows for company certification options, four per row.
 */

import styles from "./Certifications.module.css";

const CertificationCheckboxRows = ({
  certifications,
  selectedCertifications,
  onCheckboxChange,
  t,
}) => {
  const rows = [];
  for (let i = 0; i < certifications.length; i += 4) {
    const rowItems = certifications.slice(i, i + 4);
    rows.push(
      <div key={`row-${i}`} className={styles.checkboxRow}>
        {rowItems.map((certification) => (
          <div key={certification.value} className={styles.checkboxItem}>
            <input
              type="checkbox"
              id={certification.value}
              className={styles.checkbox}
              checked={selectedCertifications.includes(certification.value)}
              onChange={() => onCheckboxChange(certification.value)}
            />
            <label
              htmlFor={certification.value}
              className={styles.checkboxLabel}
            >
              {t(
                `components.certifications.certificationOption${
                  certification.value + 1
                }`,
              )}
            </label>
          </div>
        ))}
      </div>,
    );
  }
  return rows;
};

export default CertificationCheckboxRows;
